module.exports = __webpack_public_path__ + "img/bg-seoul-mini-semina.f9c47494.jpg";